module.exports = __webpack_public_path__ + "static/media/MDM.254d945d.svg";